import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isLoggedIn } from './lib/auth';
import LoginForm from './components/LoginForm';
import Layout from './components/Layout';
import UsersPage from './pages/UsersPage';

export default function App() {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn);

  if (!loggedIn) {
    return <LoginForm onLogin={() => setLoggedIn(true)} />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/users" replace />} />
        <Route path="/users" element={<UsersPage />} />
      </Routes>
    </Layout>
  );
}
